<template>
  <h2
    v-if="text"
    class="font-bold text-[#433D31] tracking-[-0.03em]"
    :class="subtitleClasses"
    v-html="formattedText"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  ></h2>
</template>

<script>
export default {
  name: 'ContentSubtitle',
  props: {
    text: {
      type: String,
      default: '',
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
    dataBlokC: {
      type: String,
      default: '',
    },
    dataBlokUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedText() {
      if (!this.text) return '';
      return this.isHtml ? this.text : this.escapeHtml(this.text);
    },
    subtitleClasses() {
      const sizeMap = {
        small: 'text-[1.125rem] leading-[1.5rem]',
        medium: 'text-[1.5rem] leading-[2rem]',
        large: 'text-[1.75rem] leading-[2.25rem]',
      };
      return sizeMap[this.size] || sizeMap.medium;
    },
  },
  methods: {
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter', 'aktiv-grotesk', sans-serif;
}

:deep(b),
:deep(strong) {
  font-weight: 700;
}

:deep(i),
:deep(em) {
  font-style: italic;
}

:deep(u) {
  text-decoration: underline;
}
</style>
